export const FETCH_GUIDES = 'GUIDES/FETCH';
export const SET_GUIDES = 'GUIDES/SET';
export const SET_LOADING_STATE = 'GUIDES/SET_LOADING_STATE';
